import { GridColDef } from '@mui/x-data-grid-pro'

import { useTranslation } from 'react-i18next'

import { formatPrice } from '@/shared/utils/price'
import styles from '../SalesReportsColumns.module.scss'

function useSalesReportsColumnsConfig(): GridColDef[] {
  const { t } = useTranslation()

  const renderHeader = (label: string) => (
    <p className={`${styles.tableHeaderText} body-bold-medium`}>{label}</p>
  )

  return [
    {
      field: 'number',
      headerName: t('REPORTS.COLUMNS.NUMBER'),
      width: 80,
      sortable: false,
      hideable: false,
      disableColumnMenu: true,
      headerClassName: styles.tableHeader,
      cellClassName: styles.tableCell,
      renderHeader: params => renderHeader(params.colDef.headerName ?? '')
    },
    {
      field: 'name',
      headerName: t('REPORTS.COLUMNS.NAME'),
      flex: 2,
      minWidth: 160,
      hideable: false,
      disableColumnMenu: true,
      headerClassName: styles.tableHeader,
      cellClassName: styles.tableCell,
      renderHeader: params => renderHeader(params.colDef.headerName ?? '')
    },
    {
      field: 'price',
      headerName: t('REPORTS.COLUMNS.PRICE'),
      flex: 1,
      minWidth: 80,
      disableColumnMenu: true,
      headerClassName: styles.tableHeader,
      cellClassName: styles.tableCell,
      valueFormatter: (value: number) =>
        typeof value === 'number'
          ? formatPrice(value, { withCurrency: false })
          : value,
      renderHeader: params => renderHeader(params.colDef.headerName ?? '')
    },
    {
      field: 'quantity',
      headerName: t('REPORTS.COLUMNS.QUANTITY'),
      flex: 1,
      minWidth: 80,
      disableColumnMenu: true,
      headerClassName: styles.tableHeader,
      cellClassName: styles.tableCell,
      renderHeader: params => renderHeader(params.colDef.headerName ?? '')
    },
    {
      field: 'percentage',
      headerName: t('REPORTS.COLUMNS.PERCENTAGE'),
      flex: 1,
      // Last column in the table, and it flexes to fill whatever the ones
      // before it leave. Dragging its edge only ever fought that.
      resizable: false,
      minWidth: 80,
      disableColumnMenu: true,
      headerClassName: styles.tableHeader,
      cellClassName: styles.tableCell,
      valueFormatter: (value: number) =>
        typeof value === 'number' ? `${value.toFixed(2)}%` : value,
      renderHeader: params => renderHeader(params.colDef.headerName ?? '')
    }
  ]
}

export { useSalesReportsColumnsConfig }
export default useSalesReportsColumnsConfig
